import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'

// ui-kit
import { useWindowSize } from '@navent-jobs/ui-kit/hooks/window-size'
import { ContainerFluid, Row, Col } from '@navent-jobs/ui-kit/components/grid'
import TextComponent from '@navent-jobs/ui-kit/components/text'

// mixins
import { ASalariosContainer, CustomCol, Heading, ASalariosContent, Text, Puesto, LinkASalarios } from './mixins'
import Background from '../../../../assets/images/a-salarios-background.svg'

// constants
import { DataLayers } from '../../../../constants/gtm-events-button-referencia-salarial'
import { SITE_ID } from '../../../../constants'
import features from '../../../../constants/features-per-country'

const salariosEnabled = features[SITE_ID || 'BMAR']?.salarios?.enabled

const ASalarios = ({ aviso }) => {
  const { t } = useTranslation()
  const { isMobile, isTabletPortrait, isTabletLandscape } = useWindowSize()

  const [showASalario, setShowASalario] = useState(false)

  const onClickVerSalario = () => {
    DataLayers.ReferenciaSalarialOnClick(aviso.subArea.nombre)
  }

  useEffect(() => {
    if (salariosEnabled) {
      setShowASalario(aviso && aviso.puesto && !!aviso.puesto.nombre && !!aviso.puesto.linkSeoSalario)
    }
  }, [aviso])

  if (!showASalario) {
    return null
  }

  return (
    <ASalariosContainer background={Background}>
      <ContainerFluid>
        <Row>
          <CustomCol sm={3} lg={2} xl={12} noGutter={isMobile || !isTabletPortrait}>
            <Heading>
              <TextComponent type="title" size="xs" fontWeight="semibold" variant="primary" as="h3">
                {t('fichaAviso.salarios.referenciaSalarial')}
              </TextComponent>
            </Heading>
          </CustomCol>

          <Col sm={9} lg={10} xl={12} noGutter={!isTabletLandscape}>
            <ASalariosContent>
              <Text>
                {t('fichaAviso.salarios.descubreCuantoGana')}
                <Puesto>{aviso.puesto}</Puesto>
              </Text>

              <LinkASalarios
                linkoptions={{
                  size: isMobile || isTabletPortrait || isTabletLandscape ? 'small' : 'medium',
                  variant: 'primary',
                  type: 'outline',
                }}
                href={aviso.puesto.linkSeoSalario}
                native={false}
                target="_blank"
                onClick={onClickVerSalario}
              >
                {isMobile || isTabletPortrait || isTabletLandscape ? 'Ver más' : 'Ver'}
              </LinkASalarios>
            </ASalariosContent>
          </Col>
        </Row>
      </ContainerFluid>
    </ASalariosContainer>
  )
}

const states = ({ activeAvisoStore }) => {
  const { aviso } = activeAvisoStore
  return {
    aviso,
  }
}

export default connect(states)(ASalarios)
